"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _icons = require("../../assets/icons");

var _elements = require("../../styles/elements");

var _Snackbar = require("./Snackbar.styles");

var Snackbar = function Snackbar(_ref) {
  var children = _ref.children,
      show = _ref.show,
      onClose = _ref.onClose,
      className = _ref.className,
      duration = _ref.duration;
  (0, _react.useEffect)(function () {
    var timer = null;

    if (show) {
      // After 3 seconds, set show to false to hide snackbar
      timer = setTimeout(function () {
        onClose();
      }, duration);
    } // Clear timer when unmount the component


    return function () {
      return clearTimeout(timer);
    };
  }, [show, onClose, duration]);
  return (0, _jsxRuntime.jsxs)("div", {
    css: [_elements.text.styles.text2Xs, _Snackbar.styles.base, show && _Snackbar.styles.show, process.env.NODE_ENV === "production" ? "" : ";label:Snackbar;"],
    className: className,
    children: [(0, _jsxRuntime.jsx)(_icons.Check, {}), (0, _jsxRuntime.jsx)("span", {
      children: children
    })]
  });
};

Snackbar.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]).isRequired,
  // Show snackbar
  show: _propTypes.bool.isRequired,
  onClose: _propTypes.func.isRequired,
  className: _propTypes.string,
  duration: _propTypes.number
};
Snackbar.defaultProps = {
  className: undefined,
  duration: 3000
};
var _default = Snackbar;
exports["default"] = _default;
//# sourceMappingURL=Snackbar.js.map